import React from "react";
import { ChevronDown } from "lucide-react";

export interface FilterSelectOption {
  value: string;
  label: string;
}

export interface FilterSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: FilterSelectOption[];
  allLabel?: string;
  className?: string;
  ariaLabel?: string;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
  label,
  value,
  onChange,
  options,
  allLabel = "All",
  className = "",
  ariaLabel,
}) => {
  return (
    <div className={`flex flex-col gap-0.5 min-w-0 ${className}`}>
      <label className="text-[10px] font-semibold uppercase tracking-wider text-stone-400 dark:text-stone-500 font-sans truncate">
        {label}
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          aria-label={ariaLabel || label}
          title={options.find((opt) => opt.value === value)?.label || allLabel}
          className="w-full appearance-none bg-white dark:bg-stone-900 text-stone-800 dark:text-stone-200 border border-stone-200 dark:border-stone-800 hover:border-stone-300 dark:hover:border-stone-700 pl-2 pr-5 py-1 text-[11px] sm:text-xs font-medium font-sans truncate transition-colors focus:outline-hidden focus:ring-1 focus:ring-stone-400 dark:focus:ring-stone-600 focus:border-stone-400 dark:focus:border-stone-600 cursor-pointer shadow-2xs"
        >
          <option
            value="all"
            className="bg-white dark:bg-stone-900 text-stone-800 dark:text-stone-200 py-1 font-sans"
          >
            {allLabel}
          </option>
          {options.map((opt) => (
            <option
              key={opt.value}
              value={opt.value}
              className="bg-white dark:bg-stone-900 text-stone-800 dark:text-stone-200 py-1 font-sans"
            >
              {opt.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-1.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-stone-400 dark:text-stone-500" />
      </div>
    </div>
  );
};
